//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "staffentryworkinfo",
     props:{
        //业务数据
        record:{type:Object,default: () => ({})},
        //流程数据
        process:{type:Object,default: () => ({})},
        //规则绑定
        rules:{type: Object,default: () => ({})},
        //自定义的参数
        config: {type: Object, default: () => ({})},
    },
    data(){
        return{
          //称谓
          fappellationList:[],
        }
    },
    methods:{
         /**
         * 初始化下拉框
         */
        initSelect(){
          let p_fappellation = {
              showcode:'fappellationList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"FAPPELLATION","paras1":"1"}
          };
          let params = [];
          params.push(p_fappellation);
          if(this.isNotNullOrEmpty(this.config.dropUrl)){
            this.initDropDownWithUrl(this,params,this.config.dropUrl);
          }else{
            this.initDropDown(this,params);
          }
        },
        /**
         * 校验出生日期
         */
        async checkfbirth(){  
          var len = this.record.familyrow.length;
          var flag = true;
          for(let i = 0 ; i < len; i++ ){
            if(this.record.familyrow[i].fbirth !=null && this.record.familyrow[i].fbirth != ''){
              let fbirth = this.forMatDate(this.record.familyrow[i].fbirth);
              var t_day = new Date();
              var month = t_day.getMonth()+1;
              if(month < 10){
                month = "0"+month;
              }

              var day =  t_day.getDate();
              if(day <10){
                day = "0"+day;
              }
              var today =  t_day.getFullYear()+"-" + month + "-" + day;
               //计算时间几个月份
              if (fbirth >= today) {
                flag = false
              }
            }
          }
          return flag;
        }
    },
    created() {
        this.initSelect();
    },
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/staffentryfamilyinfo.vue